var _path, _mask, _g, _mask2, _g2, _path2, _circle, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgViewBoardMeeting = function SvgViewBoardMeeting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 661 576",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F4654",
    d: "M0 0h661v576H0z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "view-board-meeting_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 0,
    width: 406,
    height: 307
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M255 0h406v307H255z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43,
    fill: "#fff",
    mask: "url(#view-board-meeting_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M817.812 181.482H468.864A129.192 129.192 0 01598.051 52.351H947a129.192 129.192 0 01-129.188 129.131z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M630.511 129.131H281.565A129.193 129.193 0 01410.755 0h348.946a129.18 129.18 0 01-129.19 129.131zM520.013 292H359.509a129.197 129.197 0 0137.853-91.31 129.17 129.17 0 0191.317-37.821h160.504a129.183 129.183 0 01-37.851 91.312A129.16 129.16 0 01520.013 292z"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "view-board-meeting_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 292,
    width: 464,
    height: 284
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#C4C4C4",
    d: "M0 292h463.099v284H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#view-board-meeting_svg__b)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M203.894 576h-336.101c.013-32.913 13.128-64.475 36.462-87.744 23.333-23.27 54.975-36.343 87.968-36.346h336.11c-.013 32.916-13.129 64.478-36.465 87.748C268.533 562.928 236.889 576 203.894 576zM37.252 434h-337.045c.013-32.915 13.166-64.478 36.567-87.748 23.4-23.27 55.132-36.342 88.218-36.342h337.035a123.527 123.527 0 01-9.502 47.495 124.062 124.062 0 01-27.049 40.261 124.793 124.793 0 01-40.48 26.897A125.31 125.31 0 0137.252 434z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M299.642 496.685H44.334c.013-32.915 13.157-64.478 36.54-87.748 23.385-23.27 55.095-36.342 88.158-36.342h255.247a123.511 123.511 0 01-9.465 47.497 123.972 123.972 0 01-27.016 40.268 124.601 124.601 0 01-40.446 26.898 125.059 125.059 0 01-47.71 9.427z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214 200.437h253a3 3 0 013 3v154.618a3 3 0 01-3 3H214a3 3 0 01-3-3V203.437a3 3 0 013-3z",
    fill: "#2C3E50",
    stroke: "#33BB40",
    strokeWidth: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 338.092,
    cy: 261.483,
    r: 35.087,
    fill: "#33BB40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M357.844 271.457a790.175 790.175 0 01-7.762-7.57c-.138-.136-.554-.204-.693-.136-1.316.682-2.495 1.5-3.465 2.591-1.316 1.569-2.217 3.342-2.564 5.32-7.345.204-15.314-6.342-15.314-15.071.138-.068.277-.068.485-.137 3.465-.75 5.959-2.659 7.553-5.796.069-.205 0-.614-.208-.75-2.495-2.523-5.059-4.978-7.553-7.433-.347-.341-.693-.341-1.04 0a571.2 571.2 0 00-6.444 6.41 1.473 1.473 0 00-.347.545c-.97 3.342-1.247 6.752-.693 10.229 1.178 7.365 5.059 13.025 11.504 16.981 3.603 2.182 7.553 3.273 11.711 3.409a26.447 26.447 0 007.692-.954c.138-.069.346-.137.485-.273l6.583-6.479c.347-.341.347-.613.07-.886z",
    fill: "#2F4654"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M281.304 368.711c7.238-3.009 12.255-10.172 12.255-18.481 0-11.032-8.958-20.057-20.066-20.057-11.108 0-20.066 8.954-20.066 20.057 0 8.309 5.088 15.472 12.255 18.481-15.193 3.08-26.659 16.547-26.659 32.736h69.012c0-16.189-11.466-29.656-26.731-32.736zm-7.668 31.304l-6.234-6.662 5.088-18.41-.645-4.298h3.583l-.645 4.298 5.088 18.41-6.235 6.662zM420.36 371.353h6.431c-2.948-2.409-1.072-15.256-.268-20.208.268-1.472.402-2.944.134-4.416-1.34-9.368-9.378-16.729-19.291-16.729-8.975 0-16.611 6.156-18.755 14.454-.669 2.275-.669 4.817-.134 7.092.938 4.818 2.68 16.194-.535 19.673h6.564C381.511 375.502 372 387.68 372 402h71c0-14.32-9.511-26.498-22.64-30.647zm-.402 16.729L407.5 399.19l-12.458-11.108 1.339-8.298-9.779-2.81 8.306-5.487 12.458 27.703 12.459-27.703 8.305 5.487-9.779 2.81 1.607 8.298z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M350.492 370.047c10.56-4.394 17.879-14.854 17.879-26.989 0-16.109-13.07-29.289-29.276-29.289-16.207 0-29.277 13.075-29.277 29.289 0 12.135 7.424 22.595 17.88 26.989-22.166 4.498-38.896 24.164-38.896 47.805h100.69c0-23.641-16.729-43.307-39-47.805zm-11.188 45.713l-9.097-9.728 7.424-26.884-.941-6.277h5.228l-.941 6.277 7.423 26.884-9.096 9.728z",
    fill: "#fff"
  })));
};

export default SvgViewBoardMeeting;